import { useTranslation } from 'react-i18next';

export default function Description() {
  const { t } = useTranslation();

  return (
    <section className="py-24 px-4 bg-gray-50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-center mb-12 text-gray-900">
          {t('desc_title')}
        </h2>

        <div className="space-y-6 text-gray-700 text-base md:text-lg lg:text-xl xl:text-2xl leading-relaxed">
          <p className="text-center mx-auto max-w-4xl">
            {t('desc_p1')}
          </p>
          <p className="text-center mx-auto max-w-4xl">
            {t('desc_p2')}
          </p>
          <p className="text-center mx-auto max-w-4xl">
            {t('desc_p3')}
          </p>
          <p className="text-center mx-auto max-w-4xl">
            {t('desc_p4')}
          </p>
        </div>
      </div>
    </section>
  );
}
